// extracted by mini-css-extract-plugin
module.exports = {"team":"team_team__3RPAu","team__titles":"team_team__titles__QMItC","team__wrap":"team_team__wrap__3jah2","team__block":"team_team__block__29Z8v","footer":"team_footer__2KPD9"};